/**
 * TanStack Query configuration.
 */

import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export function QueryProvider({ children }) {
  // Created once per app instance rather than at module scope, so a remount
  // never shares a cache across two different sessions.
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60_000,
            gcTime: 10 * 60_000,
            refetchOnWindowFocus: false,
            retry(failureCount, error) {
              // Never retry a deliberate refusal — a quota or permission error
              // will fail identically every time and retrying just delays the
              // paywall the user needs to see.
              if (error?.isPaywall) return false;
              if (error?.status >= 400 && error?.status < 500) return false;
              return failureCount < 2;
            },
          },
          mutations: {
            retry: false,
          },
        },
      }),
  );

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
